/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup
 * @created at      :   2024/08/01
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    customer_cd: '',
    customer_name: '',
    mode: 0,
    pageSize: 10,
    pageNo: 1
};
export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません。',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        /**
         * search customer info
         * -----------------------------------------
         * @author : quanlh - 2024/07/25 - create
         * @params :
         * @access : private
         */
        searchCustomerInfo(context, param) {
            try {
                repository.searchCustomerInfo(param).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data.data;
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません。');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        context.commit('setTotalRows', data.Data.paging);
                    }
                });
            } catch (e) {
                console.log('searchCustomerInfo: ' + e.message);
            }
        }
    }
};
